angular.module('rightPaneModule')
  .controller('GradeSchoolsController', ['$scope', '$state', 'schoolApi', 'timeframe', 'tableSort', 'tableColumns', 'reportErrors', function($scope, $state, $schoolApi, $timeframe, $tableSort, $tableColumns, $reportErrors) {

      var updateMode = function() {
          $scope.listTableColumns = $tableColumns.getColumns('school_fractions');

          $scope.activeMetric = $state.params.sort || $scope.listTableColumns[0];
      };

      updateMode();

      $scope.years = {list: null, selected: {}};

      $scope.timeframes = {
          list: [
              {id: '7d', name: 'Last 7 Days', by: 'day', active: false},
              {id: '30d', name: 'Last 30 Days', by: 'week', active: true}
          ],
          selected: {}
      };

      var updateFrequencyData = function () {
          $scope.frequencyError = null;
          $scope.frequencyData = undefined;
          $schoolApi.getSchoolsFrequency().then(function (data) {
              $scope.frequencyData = data;
          }, function(error) {
              $scope.frequencyError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateSchools = function () {
          $scope.schoolsReportingUrl = $schoolApi.getSchoolsReportingExportUrl();
          $scope.tableError = null;
          $scope.listTableData = undefined;
          $schoolApi.getSchoolsReporting().then(function(data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data);
          }, function(error) {
              $scope.listTableData = undefined;
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateSchoolsPaging = function (e, page) {
          $state.current.data.page = page;

          $scope.tableError = null;
          $scope.listTableData = undefined;
          $schoolApi.getSchoolsReporting().then(function(data) {
              if (!$scope.listTableData) {
                  $scope.listTableData = [];
              }
              var uniqueList = _.uniq($scope.listTableData.concat(data), false, function (li) {
                  return li.id;
              });
              $scope.listTableData = uniqueList;
          }, function(error) {
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateData = function () {
          updateMode();

          if (!$state.params.timeframe) {
              $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by)
                .then(function () {
                    updateSchools();
                    updateFrequencyData();
                });
          } else {
              updateSchools();
              updateFrequencyData();
          }
      };

      var initializeData = function (e, item) {
          $scope.item = item;
          updateData();

          $scope.$on('updateSortableTable', updateData);

          $scope.$on('yearSelected', updateData);

          $scope.$on('listTableNextPage', updateSchoolsPaging);

          $scope.$on('timeframeSelected', updateData);

          $scope.$on('updateYears', function (e, years) {
              $scope.years.list = angular.copy(years);
          });

          $scope.$on('listTableRowClicked', function (e, item) {
              $scope.$emit('route', item);
          });
      };

      $scope.$on('itemReady', initializeData);
  }]);
